'use client'

import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/navigation'
import { Alert } from '@/app/[locale]/(ui)/alert'

export const OrderBlockAlert = ({ className }: { className?: string }) => {
  const t = useTranslations()

  return (
    <Alert variant="error" className={className}>
      {t.rich('Order_block_alert_message', { link: (chunks) => <Link href="/kundeservice">{chunks}</Link> })}
    </Alert>
  )
}
